import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArchivedMerchantsComponent } from './list/archived-merchants/archived-merchants.component';
import { InternalMerchantComponent } from './list/internal-merchant/internal-merchant.component';
import { ListComponent } from './list/list.component';
import { OnboarderMerchantComponent } from './list/onboarder-merchant/onboarder-merchant.component';
import { MerchantHomeComponent } from './merchant-home/merchant-home.component';
import { MerchantSignupComponent } from './merchant-signup/merchant-signup.component';
import { MerchantlistComponent } from './merchantlist/merchantlist.component';
import { MerchantsDetailsComponent } from './merchants-details/merchants-details.component';
import { QuicksettingComponent } from './quicksetting/quicksetting.component';
import { AccessGuard } from 'src/app/core/guards/access.guard';
import { EmployeeSupportPinComponent } from 'src/app/pages/employee-support-pin/employee-support-pin.component';
import { QuickActionsComponent } from './list/quick-actions/quick-actions.component';
const routes: Routes = [
  {
    path: "",
    canActivate: [AccessGuard],
    data: { permissionName: "Merchants", access: 1 },
    component: ListComponent,
  },
  {
    path: "merchant-list",
    component: MerchantlistComponent,
  },
  {
    path: "merchant-archived",
    component: ArchivedMerchantsComponent,
  },
  {
    path: "merchant-onboard",
    component: OnboarderMerchantComponent,
  },
  {
    path: "merchant-internal",
    component: InternalMerchantComponent,
  },
  {
    path: "quick-setting",
    component: QuicksettingComponent,
  },
  {
    path:"merchant-home",
    component:MerchantHomeComponent
  },
  {
    path:"merchant-details/:id",
    component:MerchantsDetailsComponent
  },
  {
    path:"merchant-signup",
    component: MerchantSignupComponent
  },
  {
    path:"quick-actions",
    component: QuickActionsComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MerchantsRoutingModule { }
